#import "../../../../common/graphql/SecureRowLevelsEntityFields.graphql"
query PaymentTypes {
  secureRowLevels(orderBy: SECURITY_LEVEL_ASC) {
    nodes {
      ...SecureRowLevelsEntityFields
    }
  }
}
